import { render, staticRenderFns } from "./MainMenuComercio.vue?vue&type=template&id=43474bde&scoped=true"
import script from "./MainMenuComercio.vue?vue&type=script&lang=js"
export * from "./MainMenuComercio.vue?vue&type=script&lang=js"
import style0 from "./MainMenuComercio.vue?vue&type=style&index=0&id=43474bde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43474bde",
  null
  
)

export default component.exports